import React from 'react';
import { useSelector } from 'react-redux';
import Footer from '../Footer/Footer';
import { iRootState } from '../redux/store';
import FeedbackConfirmationDialog from './FeedbackConfirmationDialog';
import QuoteStatus from './QuoteStatus';
import QuoteAcceptance from './QuoteAcceptance';
import { DialogNames, QuoteStatuses } from '../constants';
import PaymentStatus from './PaymentStatus';
import TermsStatus from './TermsStatus';
import { PaymentTermStatus } from '../redux/models/paymentTerms';

const QuoteFooter = function QuoteFooter(): React.ReactElement {
  const disableSignature = useSelector(
    (state: iRootState) => state.quote.isSignatureDisable
  );

  const serverNotificationDone = useSelector(
    (state: iRootState) => state.quote.serverNotificationDone
  );

  const status = useSelector((state: iRootState) => state.quote.status);

  const paymentStatus = useSelector(
    (state: iRootState) => state.quote.paymentStatus
  );
  const openDialog = useSelector(
    (state: iRootState) => state.dialog.openDialog
  );

  const isFullyPaid = paymentStatus === 'Paid';
  const isPartiallyPaid = paymentStatus === 'Partially Paid';

  const hasTerms = useSelector(
    (state: iRootState) => state.paymentTerms.terms.length > 0
  );
  const terms = useSelector((state: iRootState) => state.paymentTerms.terms);
  const anyPaid = terms.some(
    t =>
      t.paymentStatus === PaymentTermStatus.Paid ||
      t.paymentStatus === PaymentTermStatus.Pending ||
      t.paymentStatus === PaymentTermStatus.UnderReview
  );

  const showTermsStatus = anyPaid && hasTerms && !isFullyPaid;
  const showPaymentStatus = isFullyPaid;
  const showStatus =
    !disableSignature &&
    status &&
    openDialog !== DialogNames.SendFeedback &&
    status !== QuoteStatuses.Viewed &&
    !isFullyPaid &&
    !isPartiallyPaid &&
    !anyPaid;

  const showAcceptance =
    serverNotificationDone &&
    !disableSignature &&
    !showStatus &&
    !isFullyPaid &&
    !anyPaid;

  return (
    <>
      <FeedbackConfirmationDialog />
      <Footer>
        <>
          {showStatus && <QuoteStatus />}
          {showAcceptance && <QuoteAcceptance />}
          {showPaymentStatus && <PaymentStatus />}
          {showTermsStatus && <TermsStatus />}
        </>
      </Footer>
    </>
  );
};

export default QuoteFooter;
